import { render, staticRenderFns } from "./MarginalityReport.vue?vue&type=template&id=18fa55c4&"
import script from "./MarginalityReport.vue?vue&type=script&lang=ts&"
export * from "./MarginalityReport.vue?vue&type=script&lang=ts&"
import style0 from "./MarginalityReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports